import {useCallback, useEffect, useState} from 'react';
import {fetchTriggersApi} from '../api/triggersApi';

export function useTriggers() {
    const [triggers, setTriggers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await fetchTriggersApi();
            setTriggers(data);
        } catch (e) {
            setError(e.message || 'Ошибка при загрузке');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return {triggers, loading, error, reload: load};
}
